import { format_price } from "../utils/cart-utils"

const PREVIEW_WIDTH = 85 * 2
const PREVIEW_HEIGHT = 85 * 2

const cartModalMixin = {
    data: {
        cartItems: [],
        cartTotal: {},
        isCartLoading: false,
        isCheckoutLoading: false
    },

    computed: {
        cartCounter() {
            let length = 0;

            this.cartItems.forEach((item) => {
                length += item.quantity
            })

            return length
        },
    },

    watch: {},

    created() {
        // Check module instance
        if (!this.moduleInstance) return console.log("[beforeCreate] - Please store module instance 'this' into 'this.moduleInstance'")

        // Get cart state
        const cartInitialState = this.moduleInstance.cartInitialState
        
        // Set cart data
        this.setCartData(cartInitialState, true)
    },

    mounted() {
        this?.bindEvents?.()
    },

    beforeDestroy() {
        this?.unbindEvents?.()
    },

    methods: {
        setCartData(cartState, isForced) {
            // Get items
            const cartItems = cartState.items
            this.updateCartItems(cartItems)

            // Get cart price
            const { original_total_price: originalTotal, total_price: total, total_discount: discount } = cartState;
            this.cartTotal = {
                originalTotal: format_price(originalTotal), 
                total: format_price(total), 
                discount: format_price(discount)
            }

            // Module Instance
            if (!isForced) {
                this.moduleInstance?.setCartData?.(cartState)
            }
        },

        updateCartItems(cartItems) {
            // Change cart item model
            this.cartItems = cartItems.map((item) => {
                let image = null
                if (item.image) {
                    image = PREVIEW_WIDTH && PREVIEW_HEIGHT ? this.getResizedImageUrl(item.image) : item.image
                }
                return {
                    key: item.key,
                    id: item.id,
                    title: item.product_title,
                    category: item.product_type,
                    image,
                    price: format_price(item.final_line_price),
                    originalPrice: format_price(item.original_line_price),
                    quantity: item.quantity,
                    options: item.options_with_values,
                    url: item.url
                }
            })
        },

        

        onAddNewItem(cartState) {
            // Set latest added item
            if (cartState.latestItemAddedId) {
                this.latestItemAddedId = cartState.latestItemAddedId
            }

            // Reordered cart
            const reorderedCart = this.reorderCart(cartState)

            this.setCartData(reorderedCart)
        },

        async onAddItem(itemKey) {
            const item = this.cartItems.find(item => item.key === itemKey)
            const quantity = item.quantity + 1

            // Start loading
            this.$set(item, 'isLoading', true)
            this.isCartLoading = true

            // Get New Cart
            const newCartState = await this.moduleInstance.updateItem({
                key: itemKey,
                quantity
            })

            // End loading
            this.$set(item, 'isLoading', false)
            this.isCartLoading = false

            // Reordered cart
            const reorderedCart = this.reorderCart(newCartState)

            // Set cart data
            this.setCartData(reorderedCart)
        },

        async onRemoveItem(itemKey) {
            const item = this.cartItems.find(item => item.key === itemKey)
            const quantity = item.quantity - 1

            // Start loading
            this.$set(item, 'isLoading', true)
            this.isCartLoading = true

            // Get New Cart
            const newCartState = await this.moduleInstance.updateItem({
                key: itemKey,
                quantity
            })

            // End loading
            this.$set(item, 'isLoading', false)
            this.isCartLoading = false

            // Reordered cart
            const reorderedCart = this.reorderCart(newCartState)

            // Set cart data
            this.setCartData(reorderedCart)
        },

        async onDeleteItem(itemKey) {
            // Start Loading
            this.isCartLoading = true

            // Get New Cart
            const newCartState = await this.moduleInstance.removeItem(itemKey)

            // End Loading
            this.isCartLoading = false

            // Set cart data
            this.setCartData(newCartState)
        },

        reorderCart(cart) {
            if (!this.latestItemAddedId) return cart

            // We need to add the latest item at the first position in the cart
            // Get last item added index
            const arrayTargetIndex = cart.items.map(item => item.id).indexOf(this.latestItemAddedId);
            if (arrayTargetIndex > -1) {
                // Remove this target item from cart items array
                const targetObject = cart.items.splice(arrayTargetIndex, 1)[0];
                // Then push this item at the first position
                cart.items.unshift(targetObject)
            } else {
                return cart
            }

            return cart
        },

        onOpen() {},

        onClose() {
            this.moduleInstance?.onCloseModal?.()
        },

        onCheckout() {
            this.isCheckoutLoading = true
        },

        getResizedImageUrl(imageUrl) {
            const splitUrl = imageUrl.split('.')
            const sizeExtension = `_${PREVIEW_WIDTH}x${PREVIEW_HEIGHT}_crop_center.${splitUrl.pop()}`
            return splitUrl.join('.') + sizeExtension
        }
    }
}

export default cartModalMixin;
